import * as React from 'react';
import { ContactUs } from '../components/contact-us';
import { FindUs } from '../components/find-us';
import { Main } from '../layouts/main';
import { Welcome } from '../components/welcome';
import { About } from '../components/about';

export default function IndexPage(): React.ReactNode {
  return (
    <Main noTopPadding={true}>
      <Welcome />
      <About />
      <ContactUs />
      <FindUs />
    </Main>
  );
}
